<template>
  <!-- rating -->
  <section class="wp_ratingsRivews"
											id="showReview">
    <div class="row pr-0 mr-0">
      <!-- new addings -->
      <div class="col-12 pr-0 mr-0 row pl-0 pl-md-5">
        <div class="col-6  pr-0 pr-md-2">
          <br>
          <h4 id="pdt-ratingreview-head"
														data-test="productRatingSectionHeading">
            <b data-test="productRatingSectionBold"
															id="productRatingSectionBold">Ratings & Reviews</b>
          </h4>
          <br>
        </div>
        <div
          class="col-6 pt-4 rate-button"
          v-if="!isAuthenticated"
          style="text-align: center;"
        >
          <router-link
            to="/user/orders/orderRating"
            tag="button"
												data-test="productRatingSectionLink1"
												id="productRatingSectionLink1"
          >
            Rate Product
          </router-link>
        </div>
        <div
          class="col-6 pt-4 rate-button"
          v-if="isAuthenticated"
          style="text-align: right;"
        >
          <button @click.prevent="getOrderProduct"
																		data-test="productRatingSectionLink2"
																		id="productRatingSectionLink2">
            Rate Product
          </button>
        </div>
      </div>

      <!-- raing -->
      <div
        class="col-12 pl-0 pl-lg-3 pr-0 mr-0"
        v-if="product.review && product.review.averageRating > 0"
      >
        <div class="row pr-0 mr-0">
          <div class="col-12 pl-0 pr-0 mr-0">
            <div class="row">
              <div class="col-4 col-lg-4">
                <div class="rating-cricle">
                  <div class="top-wrapper">
                    <h1
                      v-if="product.review&&product.review.averageRating"
                      id="pdt-average-rating1"
																						data-test="productRatingSectionHead1"
                    >
                      <strong id="pdt-average-rating2"
																														data-test="productRatingSectionAverageRating">
                        {{product.review.averageRating.toFixed(1)}}
                      </strong>
                    </h1>
                    <div class="wp_RatingStarBig">
                      <svg
                        xmlns:xlink="http://www.w3.org/1999/xlink"
                        class="wp_RatingStarFill"
                        version="1.1"
                        id="Layer_1"
                        xmlns="http://www.w3.org/2000/svg"
                        x="0px"
                        y="0px"
                        viewBox="0 0 512 512"
                        enable-background="new 0 0 512 512"
                        xml:space="preserve"
																								data-test="productRatingSectionRatingStarBig"
                      >
                        <polygon points="255.999,19.827 314.622,200.247 504.327,
                      200.247 350.853,311.754 409.472,
                      492.174 255.999,380.668 102.525,492.174 161.146,
                      311.754 7.673,200.247 197.378,200.247 ">
                        </polygon>
                      </svg>
                    </div>
                  </div>
                  <span
                    class="details"
                    v-if="product.review &&
                        product.review.productReviews &&
                        product.review.productReviews.length > 0"
																				data-test="productRatingSectionRating&Review"
																				id="productRatingSectionRating&Review"
                  >
                    {{product.review.productReviews.length}} Ratings &
                    {{product.review.productReviews.length}} Reviews
                  </span>
                </div>
              </div>
              <div
                class="d-none col-0 col-lg-8 prdt-rating-stars
                     mt-0 mt-lg-4 pr-0"
                id="pdt-rating"
                data-test="pdt-rating"
              >
                <star-rating
                  v-model="product.review.averageRating"
                  :show-rating="false"
                  :read-only="true"
                  :star-size="40"
                  :increment=".1"
                >
                </star-rating>
              </div>
              <div class="col-8 col-lg-8 pr-0 mr-0">
                <!-- New Progress Bar -->
                <div class="wp_ProgressNewContainer">
                  <!-- 5 star -->
                  <div class="wp_ratingProgressContainer position-relative">
                    <div class="wp_ratingStar_LabelConatiner">
                      <span data-test="productRatingSectionStar5"
																												id="productRatingSectionStar5">5</span>
                      <span class="wp_span"
																												data-test="productRatingSectionStar5SvgSpan"
																												id="productRatingSectionStar5SvgSpan">
                        <svg
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="wp_RatingStarFill"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          xml:space="preserve"
																										data-test="productRatingSectionStar5Svg"
                        >
                          <polygon points="255.999,19.827 314.622,
                          200.247 504.327,200.247 350.853,
                          311.754 409.472,492.174 255.999,380.668 102.525,
                          492.174 161.146,311.754 7.673,
                          200.247 197.378,200.247 ">
                          </polygon>
                        </svg>
                      </span>
                    </div>
                    <div class="wp_ProgressContaionerRating">
                      <div
                        class="wp_progressColorGreen"
                        :style="calculateRating(product.review.starCount5)"
																								data-test="productRatingSectionStar5Calculate"
																								id="productRatingSectionStar5Calculate"
                      ></div>
                    </div>
                    <div class="wp_containerTotalRating"
																									data-test="productRatingSectionStar5Count"
																									id="productRatingSectionStar5Count">
                      {{product.review.starCount5}}
                    </div>
                  </div>
                  <!-- 5 star -->

                  <!-- 4 star -->
                  <div class="wp_ratingProgressContainer position-relative">
                    <div class="wp_ratingStar_LabelConatiner">
                      <span data-test="productRatingSectionStar4"
																												id="productRatingSectionStar4">4</span>
                      <span class="wp_span"
																												data-test="productRatingSectionStar4SvgSpan"
																												id="productRatingSectionStar4SvgSpan">
                        <svg
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="wp_RatingStarFill"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          xml:space="preserve"
																										data-test="productRatingSectionStar4Svg"
                        >
                          <polygon points="255.999,19.827 314.622,200.247 504.327,
                            200.247 350.853,311.754 409.472,492.174 255.999,
                            380.668 102.525,492.174 161.146,
                            311.754 7.673,200.247 197.378,200.247 ">
                          </polygon>
                        </svg>
                      </span>
                    </div>
                    <div class="wp_ProgressContaionerRating">
                      <div
                        class="wp_progressColorGreen"
                        :style="calculateRating(product.review.starCount4)"
																								data-test="productRatingSectionStar4Calculate"
																								id="productRatingSectionStar4Calculate"
                      ></div>
                    </div>
                    <div class="wp_containerTotalRating"
																									data-test="productRatingSectionStar4Count"
																									id="productRatingSectionStar4Count">
                      {{product.review.starCount4}}
                    </div>
                  </div>
                  <!-- 4 star -->

                  <!-- 3 star -->
                  <div class="wp_ratingProgressContainer position-relative">
                    <div class="wp_ratingStar_LabelConatiner">
                      <span data-test="productRatingSectionStar3"
																												id="productRatingSectionStar3">3</span>
                      <span class="wp_span"
																												data-test="productRatingSectionStar3SvgSpan"
																												id="productRatingSectionStar3SvgSpan">
                        <svg
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="wp_RatingStarFill"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          xml:space="preserve"
																										data-test="productRatingSectionStar3Svg"
                        >
                          <polygon points="255.999,19.827 314.622,200.247 504.327,
                            200.247 350.853,311.754 409.472,492.174 255.999,
                            380.668 102.525,492.174 161.146,311.754 7.673,
                            200.247 197.378,200.247 "></polygon>
                        </svg>
                      </span>
                    </div>
                    <div class="wp_ProgressContaionerRating">
                      <div
                        class="wp_progressColorGreen"
                        :style="calculateRating(product.review.starCount3)"
																								data-test="productRatingSectionStar3Calculate"
																								id="productRatingSectionStar3Calculate"
                      ></div>
                    </div>
                    <div class="wp_containerTotalRating"
																									data-test="productRatingSectionStar3Count"
																									id="productRatingSectionStar3Count">
                      {{product.review.starCount3}}
                    </div>
                  </div>
                  <!-- 3 star -->

                  <!-- 2 star -->
                  <div class="wp_ratingProgressContainer position-relative">
                    <div class="wp_ratingStar_LabelConatiner">
                      <span data-test="productRatingSectionStar2"
																												id="productRatingSectionStar2">2</span>
                      <span class="wp_span"
																												data-test="productRatingSectionStar2SvgSpan"
																												id="productRatingSectionStar2SvgSpan">
                        <svg
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="wp_RatingStarFill"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          xml:space="preserve"
																										data-test="productRatingSectionStar2Svg"
                        >
                          <polygon points="255.999,19.827 314.622,
                          200.247 504.327,200.247 350.853,
                          311.754 409.472,492.174 255.999,
                          380.668 102.525,492.174 161.146,311.754 7.673,
                          200.247 197.378,200.247 ">
                          </polygon>
                        </svg>
                      </span>
                    </div>
                    <div class="wp_ProgressContaionerRating">
                      <div
                        class="wp_progressColorOrange"
                        :style="calculateRating(product.review.starCount2)"
																								data-test="productRatingSectionStar2Calculate"
																								id="productRatingSectionStar2Calculate"
                      ></div>
                    </div>
                    <div class="wp_containerTotalRating"
																									data-test="productRatingSectionStar2Count"
																									id="productRatingSectionStar2Count">
                      {{product.review.starCount2}}
                    </div>
                  </div>
                  <!-- 2 star -->

                  <!-- 1 star -->
                  <div class="wp_ratingProgressContainer position-relative">
                    <div class="wp_ratingStar_LabelConatiner">
                      <span data-test="productRatingSectionStar1"
																												id="productRatingSectionStar1">1</span>
                      <span class="wp_span"
																												data-test="productRatingSectionStar1SvgSpan"
																												id="productRatingSectionStar1SvgSpan">
                        <svg
                          xmlns:xlink="http://www.w3.org/1999/xlink"
                          class="wp_RatingStarFill"
                          version="1.1"
                          id="Layer_1"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          viewBox="0 0 512 512"
                          enable-background="new 0 0 512 512"
                          xml:space="preserve"
																										data-test="productRatingSectionStar1Svg"
                        >
                          <polygon points="255.999,19.827 314.622,
                          200.247 504.327,200.247 350.853,311.754 409.472,
                          492.174 255.999,380.668 102.525,
                          492.174 161.146,311.754 7.673,200.247 197.378,200.247 ">
                          </polygon>
                        </svg>
                      </span>
                    </div>
                    <div class="wp_ProgressContaionerRating">
                      <div
                        class="wp_progressColorRed"
                        :style="calculateRating(product.review.starCount1)"
																								data-test="productRatingSectionStar1Calculate"
																								id="productRatingSectionStar1Calculate"
                      ></div>
                    </div>
                    <div class="wp_containerTotalRating"
																									data-test="productRatingSectionStar1Count"
																									id="productRatingSectionStar1Count">
                      {{product.review.starCount1}}
                    </div>
                  </div>
                  <!-- 1 star -->
                </div>
                <!-- New Progress Bar -->
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- raing -->

      <!-- comments -->

      <div
        class="col-12 col-md-12 pl-0 pl-lg-5 pr-0 mr-0 mt-0 mt-lg-5 mt-md-0"
        v-if="product.review && product.review.productReviews &&
            product.review.productReviews.length > 0"
      >
        <div class="row pr-0 mr-0">
          <div
            class="col-12 pl-0 pr-0 mr-0"
            v-if="product.review&&product.review.productReviews"
          >
            <div
              class="row mt-2 pr-0 mr-0 product-review"
              v-for="(review,key) in product.review.productReviews"
              :key="key"
            >
              <div class="col-8 pr-0 mr-0">
                <div
                  class="wp_userRatingStarConatiner"
                  :id="'review-rating-'+key"
                >
                  <div class="wp_userRiviewPoint"
																							:data-test="'productRatingSectionRating'+key"
																							:id="'productRatingSectionRating'+key">
                    {{review.rating}}
                  </div>
                  <svg
                    xmlns:xlink="http://www.w3.org/1999/xlink"
                    class="wp_RatingStarFill"
                    version="1.1"
                    id="Layer_1"
                    xmlns="http://www.w3.org/2000/svg"
                    x="0px"
                    y="0px"
                    viewBox="0 0 512 512"
                    enable-background="new 0 0 512 512"
                    xml:space="preserve"
																				:data-test="'productRatingSectionRatingSvg'+key"
                  >
                    <polygon points="255.999,19.827 314.622,200.247 504.327,
                    200.247 350.853,311.754 409.472,492.174 255.999,
                    380.668 102.525,492.174 161.146,311.754 7.673,
                    200.247 197.378,200.247 ">
                    </polygon>
                  </svg>
                </div>
                <h5
                  class="wp_ReviewCaptionH5"
                  :id="'review-title-'+key"
																		:data-test="'productRatingSectionRatingTitle'+key"
                >
                  {{review.review_title}}
                </h5>

                <!--<small>Updated 12.01.2018</small>-->
              </div>

              <div class="col-12 pr-0 mr-0">
                <p
                  class="review-text "
                  :id="'review-taxt-'+key"
																		:data-test="'productRatingSectionRatingText'+key"
                >
                  {{review.review_text}}
                  <!--<span>More</span>-->
                </p>
              </div>
              <div
                class="col-12 pr-0 mr-0"
                v-if="review.image_urls.length"
              >
															<review-image-lightbox
                  :review="review"
                  :productId="product.product_id"
                  :index="key"
                  @commentReview="commentReview($event)"
                />
                <!--<LightBox :images="images"></LightBox>-->
              </div>

              <div class="col-12 pr-0 mr-0">
                <review-footer
                  :review="review"
                  :productId="product.product_id"
                  :index="key"
                  @commentReview="commentReview($event)"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- comments -->
      <!-- new addings -->
      <div
        v-if="product.review &&
                 product.review.productReviews &&
                 product.review.productReviews.length === 0"
        class="col-12 col-md-12 pb-3"
      >
        <h6 data-test="productRatingSectionNoReview"
												id="productRatingSectionNoReview">No Reviews for this products...</h6>
      </div>
    </div>
    <!-- row end -->
  </section>
</template>
<script>
import { customerApi } from '@/services/ApiServices/customerApi'
import { orderApi } from '@/services/ApiServices/orderApi'
import StarRating from 'vue-star-rating'
import { mapGetters } from 'vuex'
import ReviewImageLightbox from './review/imageContainers/ReviewImageLightbox'
import ReviewFooter from './review/ReviewFooter'

export default {
	name: 'product-rating-section',
	data () {
		return {
			review: {
				review_title: '',
				review_text: '',
				rating: 0,
				image_urls: []
			},
			product_id: '',
			product_name: '',
			images: [
				{
					thumb:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697464808-fc8b5322-a0cb-418b-bbea-b7003e3980dc.jpg',
					src:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697464808-fc8b5322-a0cb-418b-bbea-b7003e3980dc.jpg',
					caption: 'caption to display. receive <html> <b>tag</b>'
				},
				{
					thumb:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697465043-93a10a81-9c7f-451a-ae02-00c08eaa5cf0.jpg',
					src:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697465043-93a10a81-9c7f-451a-ae02-00c08eaa5cf0.jpg"\n',
					caption: 'caption to display. receive <html> <b>tag</b>'
				},
				{
					thumb:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697465867-4a7be28c-45ba-48e4-83bc-685b9ef58de3.jpg',
					src:
            'https://tst-ecommerce.s3.amazonaws.com/test-client-id/PROFILE-PICTURES/1697465867-4a7be28c-45ba-48e4-83bc-685b9ef58de3.jpg',
					caption: 'caption to display. receive <html> <b>tag</b>'
				}
			]
		}
	},
	props: {
		product: {}
	},
	components: {
		ReviewFooter,
		ReviewImageLightbox,
		StarRating
	},
	computed: {
		...mapGetters('user', ['isAuthenticated']),
		...mapGetters('productselected', ['getSelectedProduct'])
	},
	methods: {
		commentReview (productId) {
			this.$emit('commentReview', productId)
		},
		getOrderProduct () {
			for (let i = 0; i < this.getSelectedProduct.length; i += 1) {
				this.product_id = this.getSelectedProduct[i].product_id
				this.product_name = this.getSelectedProduct[i].product_name
			}
			orderApi.getOrderStatus(this.product_id)
				.then((res) => {
					if (res.data.delivered_status && res.data.is_ordered) {
						this.$router.push({
							path: '/user/orders/orderRating',
							query: {
								orderProductId: this.product.product_id,
								orderVendorId: this.product.vendor_id
							}
						})
					} else if (res.data.delivered_status || res.data.is_ordered) {
						// this.$router.push({
						//   path: '/product_description',
						//   query: { productName: this.product_name,
						//     productId: this.product_id,
						//   },
						// });
						this.$toasted.show('Only ordered, product haven\'t delivered yet')
					} else {
						// this.$router.push({
						//   path: '/product_description',
						//   query: { productName: this.product_name,
						//     productId: this.product_id,
						//   },
						// });
						this.$toasted.show('Sorry! You are not allowed to review this product since you haven\'t bought it')
					}
				})
				.catch((e) => {

				})
		},
		calculateRating (val) {
			const totalReviewCount = parseInt(
				this.product.review.starCount1 +
        this.product.review.starCount2 +
        this.product.review.starCount3 +
        this.product.review.starCount4 +
        this.product.review.starCount5
			)
			let data = {}
			data = {
				width: `${parseFloat((val / totalReviewCount) * 100)}%`
			}
			return data
		},
		reviewProduct () {
			const productId = this.product.product_id
			customerApi
				.reviewProduct(productId, this.review)
				.then((res) => {
					this.review_title = ''
					this.review_text = ''
					this.rating = 0
					this.review.image_urls = []
				})
				.catch((e) => {
				})
		}
	}
}
</script>
